const u = (e) => {
  const r = document.createElement("div");
  return r.innerHTML = (e == null ? void 0 : e.trim()) || "", r;
}, i = (e) => {
  var r;
  return e.nodeName === "#text" && ((r = e.textContent) == null ? void 0 : r.trim()) === "";
}, l = ["IMG", "BR"], f = (e) => {
  const r = e.cloneNode(!0);
  return function o(n) {
    const c = n.childNodes;
    Array.from(c).forEach((t) => {
      var m, s, a;
      i(t) && ((m = t.parentElement) == null || m.removeChild(t)), t.hasChildNodes() ? o(t) : !l.includes(t.nodeName) && ((s = t.textContent) == null ? void 0 : s.trim()) === "" && ((a = t.parentNode) == null || a.removeChild(t));
    });
  }(r), Array.from(r.querySelectorAll("*:empty")).filter((o) => !l.includes(o.tagName)).forEach((o) => {
    o.remove();
  }), r;
}, y = (e) => {
  const r = e, o = r.querySelectorAll("br");
  return Array.from(o).forEach((n) => n.remove()), r;
}, A = (e) => {
  const o = e.querySelectorAll("img");
  return Array.from(o);
}, E = (e) => {
  const r = e, o = r.querySelectorAll("img");
  return Array.from(o).forEach((n) => n.remove()), r;
}, C = (e) => e == null ? void 0 : e.innerHTML;
export {
  f as clearContent,
  u as contentToHtml,
  C as elementToText,
  A as getImagesFromContent,
  y as removeBreaklines,
  E as removeImagesFromContent
};
